import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Vue3Toastify from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import App from './App.vue'
import router from './router/index.js'
import { readStoredTheme, applyTheme } from './stores/theme.js'
// Font self-hosted (bundle offline, no CDN Google): Bebas Neue (display pubblico)
// + Manrope (UI) + Archivo (intestazioni admin, più leggibili di Bebas).
import '@fontsource/bebas-neue/latin-400.css'
import '@fontsource-variable/manrope'
import '@fontsource-variable/archivo'
import './assets/app.css'

// Tema applicato prima del primo paint per evitare il flash (FOUC).
applyTheme(readStoredTheme())

const app = createApp(App)
app.use(createPinia())
app.use(router)
// Toast container globale (top-right, slide). Le durate per-toast vengono
// gestite dal wrapper `lib/toast.js` che legge `useUiPrefsStore` runtime.
app.use(Vue3Toastify, {
  position: 'top-right',
  transition: 'slide',
  theme: 'auto',
  newestOnTop: true
})
app.mount('#app')
